import { unlockBurst, unlockHalf, unlockHalfRight, unlockLabel, unlockLock, unlockShard } from './member-access.css'

const SHARDS: { x: string; y: string }[] = [
  { x: '-22px', y: '-28px' },
  { x: '20px', y: '-24px' },
  { x: '-26px', y: '8px' },
  { x: '24px', y: '14px' },
  { x: '2px', y: '-32px' },
]

function PadlockMark() {
  return (
    <svg viewBox="0 0 24 24" width="48" height="48" aria-hidden>
      <path
        d="M8 11V8a4 4 0 0 1 8 0v3"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <rect x="5" y="11" width="14" height="10" rx="2" fill="none" stroke="currentColor" strokeWidth="2" />
    </svg>
  )
}

export function MemberCatalogUnlock({ productId, onSettled }: { productId: string; onSettled: (productId: string) => void }) {
  return (
    <span
      className={unlockBurst}
      aria-hidden
      data-testid={`catalog-unlock-${productId}`}
      onAnimationEnd={(event) => {
        if (event.target !== event.currentTarget) return
        onSettled(productId)
      }}
    >
      <span className={unlockLabel}>Liberado</span>
      <span className={unlockLock}>
        <span className={unlockHalf}>
          <PadlockMark />
        </span>
        <span className={`${unlockHalf} ${unlockHalfRight}`}>
          <PadlockMark />
        </span>
      </span>
      {SHARDS.map((shard) => (
        <span
          key={`${shard.x}${shard.y}`}
          className={unlockShard}
          style={{ ['--unlock-x' as string]: shard.x, ['--unlock-y' as string]: shard.y }}
        />
      ))}
    </span>
  )
}
